import { createSelector } from 'reselect';
import { carouselOnPLPCategorySelector } from 'selectors/testTarget/offers/carouselOnPLPCategory/carouselOnPLPCategorySelector';

const enabledSelector = createSelector(carouselOnPLPCategorySelector, carouselOnPLPCategory => carouselOnPLPCategory.enabled);

export { enabledSelector };
